module.exports = __webpack_public_path__ + "static/media/logo-dash.f67e9fe7.png";